import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CountyMasterService {
  AppUrl = '';
  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }

  GetAllCounty(TokenKey: string, PageNumber: number, PageSize: number, FilterText: string, StateId: string, OrderBy: string, IsExport: boolean): Observable<any> {

    this.setAPIUrl();

    const formBody = {
      PageNumber: PageNumber,
      PageSize: PageSize,
      FilterText: FilterText,
      StateId: StateId,
      OrderBy: OrderBy,
      IsExport: IsExport
    };

    const apiUrl = this.AppUrl + 'api/countyMaster/GetAllCounty';

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Token': TokenKey
      })
    };

    return this._http
      .post<any>(apiUrl, formBody, httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  CreateOrUpdateCounty(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/countyMaster/CreateOrUpdateCounty';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetCountyById(TokenKey: string, countyId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/countyMaster/GetCountyById/' + countyId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteCounty(TokenKey: string, countyId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/countyMaster/DeleteCounty/' + countyId;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  // GetCountyByStateId(TokenKey: string, stateId: string, IsAdmin: boolean): Observable<any> {
  //   this.setAPIUrl();
  //   var data={
  //     stateId,
  //     IsAdmin
  //   }
  //   const data = 'api/countyMaster/V2/GetCountyByStateId';
  //   return this._http.post<any>(this.AppUrl + data)
  //     .pipe(catchError(this.handleError));
  // }

  GetCountyByStateId(stateId: string, IsAdmin: boolean): Observable<any> {
    this.setAPIUrl();

    const payload = {
      stateId: stateId,
      isAdmin: IsAdmin
    };

    const url = 'api/countyMaster/V2/GetCountyByStateId';

    return this._http.post<any>(
      this.AppUrl + url,
      payload
    ).pipe(
      catchError(this.handleError)
    );
  }
}
